import { Progress } from "antd";

export default function AssetAlertSummary() {
	const alertData = [
		{ label: "Controller", value: 14, color: "#f1416c" },
		{ label: "SCADA", value: 5, color: "#ff6b35" },
		{ label: "Computer", value: 1, color: "#ffc107" },
		{ label: "Network", value: 1, color: "#50cd89" },
		{ label: "Others", value: 40, color: "#7239ea" },
	];

	return (
		<div className="col-lg-4 mb-3">
			<div className="card bg-secondary h-100">
				<div className="card-body">
					<h5 className="text-white mb-6">Asset Alert Summary</h5>
					<div style={{ minHeight: "220px" }}>
						{alertData.map((item, index) => (
							<div key={index} className="mb-4">
								<div className="d-flex justify-content-between align-items-center mb-2">
									<span className="text-white fs-7">{item.label}</span>
									<span
										className="text-white fs-6 fw-bold"
										style={{ color: item.color }}
									>
										{item.value}%
									</span>
								</div>
								<Progress
									percent={item.value}
									strokeColor={item.color}
									showInfo={false}
									strokeWidth={12}
									trailColor="#2b2b40"
								/>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
